/** Rows per /audits table page. */
export const AUDITS_PER_PAGE = 40;

export type AuditsTableAmountLog = {
  value?: string | number | null
  units?: string | number | null
  data?: { units?: string | number | null }
};

/** N/A and non-numeric audit values do not move the footer total. */
export const auditsTableAmountNumber = (value?: string | number | null): number => {
  if (value == null || value === '' || value === 'N/A') return 0;
  return Number(value) || 0;
};

/**
 * Sum cash or units for every filtered audit — not the current paginator page.
 * Page-only sums jump (e.g. 0 then 16) when early pages are N/A hospitality.
 */
export const sumAuditsTableAmount = (
  logs: AuditsTableAmountLog[],
  mode: 'value' | 'units' = 'value',
): number => (
  logs.reduce((sum, log) => {
    if (mode === 'units') {
      const raw = log.units ?? log.data?.units;
      if (raw == null || raw === '') return sum;
      return sum + (Number(raw) || 0);
    }
    return sum + auditsTableAmountNumber(log.value);
  }, 0)
);

/** Slice one /audits page without mutating the filtered list. */
export const paginateAuditsTable = <T>(
  logs: T[],
  page: number,
  perPage: number = AUDITS_PER_PAGE,
): T[] => {
  const safePage = Math.max(1, page);
  const start = (safePage - 1) * perPage;
  return logs.slice(start, start + perPage);
};

export const auditsTablePageCount = (
  total: number,
  perPage: number = AUDITS_PER_PAGE,
): number => {
  if (total <= 0) return 0;
  return Math.ceil(total / perPage);
};
